// import React from 'react';
// // import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import $ from "jquery";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// window.jQuery = $;
// window.$ = $;
// global.jQuery = $;


// $("#menu-toggle").click(function () {
//     $("#wrapper").toggleClass("toggled");
// });

// $('.modal[data-reset="true"]').on('shown.bs.modal', () =>
//     $("input[name != 'timestamp']").val(''));

// $('.modal').on('shown.bs.modal', () =>
//     $('input[data-reset-input="true"]').val(''));

// // const root = ReactDOM.createRoot(document.getElementById('root'));
// // root.render(<App />);


import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
